import dayjs from 'dayjs';
import _ from 'lodash';

import { FIRST_DAY_OF_MONTH } from 'constants/date';
import { MAX_INTEREST_CREDIT_EDITABLE_DAY_IN_MONTH } from 'constants/loanPrepaids';
import {
  getDefaultInterestCreditValue,
  getFundingBusinessDays,
  WeekdayToStringMap,
} from 'utils/loanPrepaidsDates';

export const getShouldDisableFundingDate = ({
  internalHolidays = [],
  globalHolidays = [],
  preciseBusinessDays,
  countSaturdayForFunding,
}) => {
  const allHolidays = [...internalHolidays, ...globalHolidays];
  const fundingBusinessDays = getFundingBusinessDays({
    preciseBusinessDays,
    countSaturdayForFunding,
  });

  if (!fundingBusinessDays || !fundingBusinessDays.length) {
    return date => allHolidays.some(day => dayjs(day.date).isSame(dayjs(date), 'day'));
  }

  const getIsDayHolidayOrWeekend = dayToCheck => {
    const isDayHoliday = allHolidays.some(day => dayjs(day.date).isSame(dayjs(dayToCheck), 'day'));
    const isDayWeekend = !fundingBusinessDays.includes(WeekdayToStringMap[dayjs(dayToCheck).day()]);

    return isDayHoliday || isDayWeekend;
  };

  return date => getIsDayHolidayOrWeekend(date);
};

const shouldDisableFirstPaymentDate = date => date.date() !== FIRST_DAY_OF_MONTH;

// A retail first payment is always on the 1st; a chattel one is due a set number of days after
// funding on any day of the month, so only dates on or before funding are blocked (LEN-198).
export const getShouldDisableFirstPaymentDate = ({ isChattel = false, fundingDate = null } = {}) =>
  isChattel
    ? date => !_.isNil(fundingDate) && !dayjs(date).isAfter(fundingDate, 'day')
    : shouldDisableFirstPaymentDate;

export const getHasInterestCreditValue = ({
  fundingDate,
  hasInterestCredit,
  loanApplication,
  subjectPropertyState,
}) => {
  const isFundingDateExceedEditableDate =
    dayjs(fundingDate).date() > MAX_INTEREST_CREDIT_EDITABLE_DAY_IN_MONTH;
  const isInterestCreditDefault =
    (isFundingDateExceedEditableDate || !fundingDate) && hasInterestCredit;

  return isInterestCreditDefault
    ? getDefaultInterestCreditValue({ loanApplication, subjectPropertyState })
    : hasInterestCredit;
};
